<template>
  <div>
    <Map ref="map">
      <template v-slot:marker>
        <l-marker
          data-cy="marker"
          :name="marker.name"
          v-bind:lat-lng="marker.location"
          v-bind:options="{ id: marker.id }"
          :icon="markerIcon"
          :ref="marker.id"
        >
        </l-marker>
        <l-marker
          v-for="(marker, index) of measures"
          :key="`marker-${index}`"
          data-cy="marker"
          :name="`marker-${index}`"
          v-bind:lat-lng="marker.measure"
          v-bind:options="{ id: `marker-${index}` }"
          :icon="icon"
          :ref="`marker-${index}`"
        >
          <l-tooltip>
            {{ marker.date }}
          </l-tooltip>
        </l-marker>
        <l-polyline :lat-lngs="polylineLocations" class="lineColor">
        </l-polyline>
      </template>
    </Map>
  </div>
</template>

<script>
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import { LMarker, LPolyline, LTooltip } from 'vue2-leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
export default {
  name: 'DeviceMap',
  components: {
    LMarker,
    LTooltip,
    LPolyline
  },
  props: {
    measures: {
      required: true
    },
    device: {
      required: true
    }
  },
  methods: {
    initMap() {
      this.$nextTick(() => {
        this.$refs.map.$refs.map.mapObject.invalidateSize();
        this.$refs.map.$refs.map.mapObject.setView(
          new L.LatLng(this.marker.location.lat, this.marker.location.lng),
          8
        );
        this.$refs.map.$refs.map.mapObject.removeControl(
          this.$refs.map.$refs.map.mapObject.zoomControl
        );
        L.control
          .zoom({ position: 'topright' })
          .addTo(this.$refs.map.$refs.map.mapObject);
      });
    }
  },
  mounted() {
    this.initMap();
  },
  computed: {
    polylineLocations() {
      let polylines = [];
      const positions = this.measures.map(m => {
        return [m.measure.lat, m.measure.lon];
      });
      polylines = [...polylines, ...positions];
      return polylines;
    },
    marker() {
      return {
        id: this.device._id,
        name: this.device._source.reference,
        location: {
          lat: this.device._source.measures.position.point.lat,
          lng: this.device._source.measures.position.point.lon
        }
      };
    }
  },
  data() {
    return {
      numberOfPoints: 10,
      checked: false,
      mode: 'table',
      icon: new L.divIcon({
        html: '<i class="fa fa-circle dotsColor"></i>',
        className: 'hearticon',
        shadowUrl,
        iconSize: [8, 8],
        iconAnchor: [8, 8],
        popupAnchor: [1, -34],
        interactive: true
      }),
      markerIcon: new L.divIcon({
        html: '<i class="fa fa-map-marker-alt fa-3x markerColor" ></i>',
        className: 'hearticon',
        shadowUrl,
        iconSize: [20, 36],
        iconAnchor: [15, 36],
        popupAnchor: [1, -34],
        interactive: true
      })
    };
  }
};
</script>

<style lang="scss">
@import '~leaflet.markercluster/dist/MarkerCluster.css';
@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';
.switchButton {
  position: absolute;
  float: left;
  left: 15px;
  margin-top: 17px;
  z-index: 9999;
  background-color: white;
}

.markerColor {
  color: map-get($theme-colors, primary);
}

.dotsColor {
  color: map-get($theme-colors, secondary);
}

.lineColor {
  color: map-get($theme-colors, info);
}
</style>
